import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const AddUserFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M11.55 10.26a3.63 3.63 0 1 0 0-7.26 3.63 3.63 0 0 0 0 7.26Z" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.35 14.76a.9.9 0 0 0-1.8 0v1.79h-1.79a.9.9 0 1 0 0 1.8h1.79v1.8a.9.9 0 1 0 1.8 0v-1.8h1.79a.9.9 0 0 0 0-1.8h-1.79v-1.79Z"
      />
      <Path d="M19.45 15.45h.06s-.04-.08-.06-.13v.13ZM15.1 15.45h.35v-4.07a7.67 7.67 0 0 0-3.03-.62h-1.73C6.46 10.76 3 14.19 3 18.38v.86h9.82V17.7a2.292 2.292 0 0 1 2.28-2.25Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default AddUserFilled
